import type { CSSProperties } from "react";
import { bookingPageTitleStyle } from "@openings/template-components";

/** Responsive outer-card heading shared by standalone booking surfaces. */
export const standaloneCardTitleStyle: CSSProperties = {
  ...bookingPageTitleStyle,
  fontFamily:
    "var(--openings-booking-heading-font-family, inherit)",
  fontSize:
    "var(--openings-booking-card-title-font-size, 18px)",
  fontWeight:
    "var(--openings-booking-card-title-font-weight, var(--openings-booking-font-weight-semibold, 600))",
  lineHeight: "var(--openings-booking-card-title-line-height, 1.25)",
};
